/**************************************************
 * Nombre:       Seccione_Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Testimonios from "./Componentes/SubComponentes/Testimonios";
import Home_Contactos from "./Componentes/Home_Contactos";
import Catalogo_Categorias from "./Componentes/Catalogo_Categorias";
import Catalogo_Resultados from "./Componentes/Catalogo_Resultados";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";

const Seccione_Catalogo = () => {
    const parms = useParams()
    const [tipo, setTipo] = useState("")
    const [id, setId] = useState("")


    useEffect(() => {

        if (parms && parms.tipo && parms.id) {
            setId(parms.id)
            setTipo(parms.tipo)
            scrolearAComponente('resultado')
        }

    },[parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Catalogo_Categorias/>
            </Grid>

            <Grid id={'resultado'} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Catalogo_Resultados tipo={tipo} id={id} />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>

        </Grid>
    )

}
export default Seccione_Catalogo    